export const cmsService = {
  filterCMSContent,
  getContent
}

function getContent(array, filterValue) {
  return this.filterCMSContent(array, filterValue)
}

function filterCMSContent(array, filterValue) {
  if (!array.filter) {
    array = []
  }
  const filtered = array.filter(content => content.name === filterValue)
  if (filtered.length !== 0) {
    // return content if found
    const firstIndex = filtered[0]
    const returnValue = firstIndex === undefined ? '' : firstIndex.content
    return returnValue
  } else {
    // return error if in develop-stage
    // return empty string if production-stage
    return window.config.NODE_ENV === 'development'
      ? Error(`Key '${filterValue}' not found in CMS or JSON`)
      : ''
  }
}
